

















































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import { DxButton } from 'devextreme-vue/button';
import {
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxFilterRow,
  DxHeaderFilter,
  DxLookup,
  DxPaging,
  DxPopup,
  DxRequiredRule,
  DxScrolling,
  DxStateStoring
} from 'devextreme-vue/data-grid';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import TextPopup from '@/components/text-popup.vue';
import { SelectOption } from '@/models/SelectOption';
import { AnalysisTriggerRuleDto } from '@/models/analysis-triggers/AnalysisTriggerRuleDto';
import { AnalysisTriggerRuleTypeDto } from '@/models/analysis-triggers/AnalysisTriggerRuleTypeDto';
import { AnalysisTriggerRuleService } from '@/service/AnalysisTriggerRuleService';
import { AnalysisTriggerRuleTypeService } from '@/service/AnalysisTriggerRuleTypeService';
import { ClientService } from '@/service/ClientService';
import { CountryService } from '@/service/CountryService';
import { FilingTypeService } from '@/service/FilingTypeService';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import String from '@/utilities/String';
import _ from 'lodash';
import AnalysisTriggerRuleAddEdit from '@/components/analysis-triggers/analysis-trigger-rule-add-edit.vue'
import { confirm } from 'devextreme/ui/dialog';

@Component({
  components: {
    DxButton,
    DxColumn,
    DxDataGrid,
    DxEditing,
    DxFilterRow,
    DxHeaderFilter,
    DxLookup,
    DxNumberBox,
    DxPaging,
    DxPopup,
    DxRequiredRule,
    DxScrolling,
    DxSelectBox,
    DxStateStoring,
    DxTextArea,
    DxTextBox,
    TextPopup,
    AnalysisTriggerRuleAddEdit
  }
})
export default class AnalysisTriggerList extends Vue {
  private readonly analysisTriggerRuleService: AnalysisTriggerRuleService = new AnalysisTriggerRuleService();
  private readonly analysisTriggerRuleTypeService: AnalysisTriggerRuleTypeService = new AnalysisTriggerRuleTypeService();
  private readonly clientService: ClientService = new ClientService();
  private readonly countryService: CountryService = new CountryService();
  private readonly filingTypeService: FilingTypeService = new FilingTypeService();
  private readonly phaseTypeService: PhaseTypeService = new PhaseTypeService();

  private analysisTriggerRuleTypeOptions: SelectOption[] = [];
  private analysisTriggerRuleTypes: AnalysisTriggerRuleTypeDto[] = [];
  private clients: SelectOption[] = [];
  private countries: SelectOption[] = [];
  private dataGrid: dxDataGrid | undefined;
  private filingTypes: SelectOption[] = [];
  private notesToShow: string = '';
  private phaseTypes: SelectOption[] = [];
  private selectedRuleType: AnalysisTriggerRuleTypeDto | null = null;
  private selectedRuleTypeId: number | null = null;
  private showNotes: boolean = false;
  private errorMessage: string | null = null;

  $refs: Vue['$refs'] & {
      analysisTriggerRuleAddEdit?: AnalysisTriggerRuleAddEdit;
  } = {};

  private get analysisTriggerRulesDataSource() {
    return new CustomStore({
      key: 'AnalysisTriggerRuleId',
      load: options => this.analysisTriggerRuleService.list(options).catch(this.handleResponseError),
      insert: values => this.analysisTriggerRuleService.create(values).catch(this.handleResponseError),
      update: (key, values) => this.analysisTriggerRuleService.update(key, values).catch(this.handleResponseError),
      remove: key => this.analysisTriggerRuleService.delete(key).catch(this.handleResponseError)
    });
  }

  private handleResponseError(result: any) {
    let message = 'An unknown error occurred.';
    if (result != null && result.Message != null) {
      message = result.Message;

      let index = message.indexOf(' (Error');
      if (index > -1) {
        message = message.substring(0, index);
      }
    }
    this.errorMessage=message;
    throw Error(message);
  }

  async created() {
    document.addEventListener('keyup', this.onKeyup, true);
    document.addEventListener('keydown', this.onKeydown, true);
    await this.loadData();
  }

  private async loadData() {
    this.analysisTriggerRuleTypes = await this.analysisTriggerRuleTypeService.list();
    this.analysisTriggerRuleTypeOptions = this.analysisTriggerRuleTypes.map<SelectOption>(t => {
      return { text: t.RuleTypeName, value: t.AnalysisTriggerRuleTypeId };
    });

    this.clients = await this.clientService.getAllSelectOptions(true);
    this.countries = await this.countryService.getAllSelectOptions(true);
    this.phaseTypes = await this.phaseTypeService.getAllSelectOptions();

    let filingTypes = await this.filingTypeService.getTypes();
    this.filingTypes = filingTypes.map<SelectOption>(t => {
      return { text: t.Name, value: t.FilingTypeId as number };
    });
    this.filingTypes.unshift({ text: 'ALL', value: '' });
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup, true);
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  private openNotes(rule: AnalysisTriggerRuleDto) {
    this.notesToShow = rule.Notes != null ? rule.Notes : '';
    this.showNotes = true;
  }

  private closeNotes() {
    this.showNotes = false;
    this.notesToShow = '';
  }

  private showAddEditPopup: boolean = false;
  private targetRule: AnalysisTriggerRuleDto = this.resetTargetRule();

  private resetTargetRule(): AnalysisTriggerRuleDto {
    return {
        AnalysisTriggerRuleId: '00000000-0000-0000-0000-000000000000',
        AnalysisTriggerRuleTypeId: 0,
        RuleTypeName:'',
        RuleName: '',
        CreatedDate:new Date(),
        CreatedById: '',
        CreatedBy: ''
    }
  }

  private showAddEdit(rule: AnalysisTriggerRuleDto | null) {
    this.errorMessage=null;
    this.showAddEditPopup = true;
    if(rule) {
      this.targetRule = _.cloneDeep(rule);
      return;
    }
    this.targetRule = this.resetTargetRule();
  }

  private hideAddEdit(rule: AnalysisTriggerRuleDto) {
    this.showAddEditPopup = false;
    this.targetRule = this.resetTargetRule();
  }

  private saveRowData(rule: AnalysisTriggerRuleDto) {
    
    if(rule && rule.AnalysisTriggerRuleId) {
      this.analysisTriggerRulesDataSource.update(rule.AnalysisTriggerRuleId, rule).then((x: AnalysisTriggerRuleDto)=>{
        this.analysisTriggerRulesDataSource.push([{type:'update',data: x, key: x.AnalysisTriggerRuleId }]);
        this.hideAndResetPopup();
      })
    }

    if(rule && !rule.AnalysisTriggerRuleId) {
      let ruleToSend = Object.assign({},this.resetTargetRule(),rule);
      this.analysisTriggerRulesDataSource.insert(ruleToSend).then((x: AnalysisTriggerRuleDto)=>{
        if(this.dataGrid){
          this.dataGrid.refresh();
          this.hideAndResetPopup()
        }
      })
    }
  }

  private hideAndResetPopup() {
    this.showAddEditPopup=false;
    this.targetRule = this.resetTargetRule();
  }

  private removeRow(rule: AnalysisTriggerRuleDto) {
    if(rule) {
      confirm('Are you sure you want to delete this record?','Confirm Deletion').then(x=>{
        if(x) {
          this.analysisTriggerRulesDataSource.remove(rule.AnalysisTriggerRuleId).then(()=>{
            this.analysisTriggerRulesDataSource.push([{type:'remove',key: rule.AnalysisTriggerRuleId}])
          })
        }
      })
    }
  }

  private onDataGridInitialized(e: any) {
    this.dataGrid = e.component;
  }

  private customizeEmptyText(cellInfo: any) {
    return String.isNullOrEmpty(cellInfo.valueText) ? 'ALL' : cellInfo.valueText;
  }

  private customizeEmptyOptionalText(cellInfo: any) {
    return String.isNullOrEmpty(cellInfo.valueText) ? '--' : cellInfo.valueText;
  }

  private onKeydown(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  private onKeyup(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
      this.executeSave();
    }
  }

  private executeSave() {
    const addEdit = this.$refs.analysisTriggerRuleAddEdit;
    if(addEdit) {
      addEdit.validateAndSave();
    }
  }

  private isSaveShortcut(e: KeyboardEvent) {
    return e.key === 'Enter' && (e.ctrlKey || e.shiftKey);
  }

  private focusDataGrid() {
    if (this.dataGrid != null) {
      this.dataGrid.focus();
    }
  }

  private addHeaderButton(event: any) {
    event.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'add',
        onClick: this.showAddEdit
      }
    });
  }

}
